module.exports = __webpack_public_path__ + "a99b52d9efd5e491d7ad4c465f527108.svg";